import React from 'react';

export interface NotificationAlertState {
    title: string;
    content: React.ReactNode;
    variant: 'success' | 'error';
    cancelButtonLabel?: string;
}

export type ShowAlertFunction = (
    variant: 'success' | 'error',
    title: string,
    content?: React.ReactNode,
    cancelButtonLabel?: string
) => void;

export function useNotificationAlert() {
    const [currentNotification, setCurrentNotification] = React.useState<
        NotificationAlertState | undefined
    >();
    const showAlert: ShowAlertFunction = React.useCallback(
        (
            variant: 'success' | 'error',
            title: string,
            content: React.ReactNode,
            cancelButtonLabel?: string
        ) => {
            setCurrentNotification({
                title,
                content,
                variant,
                cancelButtonLabel
            });
        },
        []
    );
    const dismissAlert = React.useCallback(() => {
        setCurrentNotification(undefined);
    }, []);
    return {
        currentNotification,
        dismissAlert,
        showAlert
    };
}
